import TostActionTypes from './toast.type';

const INITIAL_STATE = {
  message: '',
  type: '',
};

const toastReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TostActionTypes.SET_TOAST:
      return {
        ...state,
        message: action.payload.message,
        type: action.payload.type,
      };
    default:
      return state;
  }
};

export default toastReducer;
